import React, { useCallback, useEffect, useState } from 'react'
import { BannerTypeBContainer, ImageWrapper } from './BannerTypeB.css'
import { ELanguage, IMAGE_URL } from '@/common'
import Image from 'next/image'
import { Button, Col, Row, Typo } from '@/libs/react-components'
import { useAppStore } from '@/app-context'
import { translations, TTranslationKey } from './translation'
import AIIcon from '../icons/AIIcon'
import { AIBeforeApply } from '@microfrontends/react-components'
import { ACTION } from '@/app-context/action'

const BannerTypeB = () => {
    const { dispatch } = useAppStore()
    const { langCode } = useAppStore().props
    const [isShowBeforeApply, setIsShowBeforeApply] = useState(false)

    const t = useCallback(
        (text: TTranslationKey) => {
            if (langCode === ELanguage.VI) {
                return translations[text] ?? text
            }
            return text
        },
        [langCode]
    )

    const onClickViewAnalysis = useCallback((placement: string) => {
        const customEvent = new CustomEvent('ON_VIEW_CV_REVIEW', {
            detail: {
                placement: placement
            }
        })
        window.dispatchEvent(customEvent)
    }, [])

    const onShowCVBeforeApply = useCallback(() => {
        setIsShowBeforeApply(true)
    }, [])

    useEffect(() => {
        window.addEventListener('SHOW_AI_CV_BEFORE_APPLY', onShowCVBeforeApply)
        return () => {
            window.removeEventListener('SHOW_AI_CV_BEFORE_APPLY', onShowCVBeforeApply)
        }
    }, [])

    return (
        <>
            <BannerTypeBContainer>
                <ImageWrapper>
                    <Image
                        src={`${IMAGE_URL}/images/AI-review-before-apply.png`}
                        fill
                        alt='AI CV Review'
                        quality={100}
                    />
                </ImageWrapper>
                <Row align='middle' gutter={[0, 8]}>
                    <Col xs='fill'>
                        <Typo name='title' size='medium' style={{ marginBottom: 8, paddingRight: 8 }}>{t('Maximize your competitive advantage before applying')}</Typo>
                        <Typo name='body' size='medium' style={{ paddingRight: 8 }}>{t('View matching analysis and compare to other applicants')}</Typo>
                    </Col>
                    <Col xs='auto'>
                        <Typo name='body' size='small'><AIIcon style={{ marginRight: 4 }} /> {t('Over 90% of users are satisfied')}</Typo>
                        <Button type='ai' outline='outline' onClick={() => onClickViewAnalysis('mini_banner_JD')} style={{ width: '100%', marginTop: 8 }}>{t('View analysis now')}</Button>
                    </Col>
                </Row>
            </BannerTypeBContainer>
            <AIBeforeApply
                langCode={langCode}
                imageUrl={IMAGE_URL ?? ''}
                showState={[isShowBeforeApply, setIsShowBeforeApply]}
                onContinueApply={() => {
                    setIsShowBeforeApply(false)
                    dispatch({
                        type: ACTION.SET_SHOW_APPLY_JOB_MODAL,
                        payload: true
                    })
                }}
                onViewAnalysis={() => {
                    setIsShowBeforeApply(false)
                    onClickViewAnalysis('before_apply_popup')
                }}
            />
        </>
    )
}

export default BannerTypeB

